(function () {
  var BULLET_HTML = 'Use Code: <span class="pbl-bf-red">CYBER for Extra 10% Off</span>';

  function hasBlackFriday(li) {
    var txt = li.textContent.replace(/\s+/g, ' ').toLowerCase();
    return txt.includes('use code') && txt.includes('blackfriday');
  }

  function isEarlyBlackFriday(li) {
    var txt = li.textContent.replace(/\s+/g, ' ').toLowerCase();
    return txt.includes('early black friday');
  }

  function hideEarlyBlackFriday(ul) {
    ul.querySelectorAll('li').forEach(function (li) {
      if (isEarlyBlackFriday(li)) {
        // Apply display: none !important
        li.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function addBullet(ul) {
    if (ul.querySelector('li.pbl-bf')) return;
    if ([].some.call(ul.querySelectorAll('li'), hasBlackFriday)) return;

    var li = document.createElement('li');
    li.className = 'pbl-bf';
    li.innerHTML = BULLET_HTML;

    ul.insertBefore(li, ul.firstElementChild || null);
  }

  function waitForList() {
    var ul = document.querySelector('ul.pbl');
    if (!ul || ul.children.length < 3) {
      return setTimeout(waitForList, 100);
    }

    hideEarlyBlackFriday(ul);
    addBullet(ul);

    new MutationObserver(function (muts) {
      muts.forEach(function () {
        hideEarlyBlackFriday(ul);
        addBullet(ul);
      });
    }).observe(ul, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForList);
  } else {
    waitForList();
  }
})();
